import React from "react";
import { constantURL } from "./ConstantURI";
import { ASAPDB } from "./ConstantURI";
import constantURI from "./URI";
import stylesCommon from "./stylesCommon";
import stylesMed from "./MedRep/stylesMed";
import EDMLogo from "./EDMLogo.png";
import ASAP from "./ASAP.png";
import _get from "./Functions/Get";
import _postBody from "./Functions/Post";
import Authenticate from "./Functions/MedRepAuthenticate";
import { Modal } from "react-bootstrap";
import _post from "./Functions/NoBodyPost";
import { FaUserAlt } from "react-icons/fa";
import { AiOutlineUserSwitch } from "react-icons/ai";
import { DiscOutline } from "react-ionicons";
import { error } from "jquery";
import Cookies from 'js-cookie';
import { clear } from 'idb-keyval';
import { getLoginLandingRoute } from "./Functions/LoginFlow";

export default class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      key: "",
      token: "",
      username: "",
      password: "",
      passwordField: "",
      encryptedPassword: "",
      checkPassword: "",
      checkUser: "",
      user: "",
      authenticate: false,
      showAlertChange: false,
      isASAP: false,
      isMedRep: false,
      isWMS: false,
      modules: [],
      clientId: [],
      alertUndefined: false,
      users: [],
      newUserId: -1,
      login: false,
      changePwdInput: "",
    };
  }

  Username(event) {
    this.setState({ username: event });
  }

  Password(event) {
    this.setState({ password: event });
  }

  ChangePwdInput(event) {
    this.setState({ changePwdInput: event });
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";
    const modules = JSON.parse(localStorage.getItem("Modules"));
    const token = localStorage.getItem("Token");
    if (!token || token === "null" || token === '""' || !modules) {
      localStorage.setItem("Token", JSON.stringify(""));
      Cookies.set('Token', JSON.stringify(""), { expires: 30 });
    }
    if (modules !== null) {
      modules.map((item) => {
        if (item === 4 || item === 5) {
          this.setState({ isWMS: true });
        }
      });
    }
    const { history } = this.props;
    this.unblock = history.block(() => {
      // Return false to deny the navigation
      return false;
    });
    localStorage.setItem("Title", JSON.stringify("CandleStick"));
    const deleteStorage = JSON.parse(localStorage.getItem("DeleteStorage"));
    const protectedKeys = [
      "PendingCashInvoicePayment",
      "CurrentCashSales",
      "CurrentTab",
      "TransactionType",
      "SelectedClient",
      "SelectedClientDetails",
      "SelectedClientName",
      "SelectedVisitId",
      "SelectedVisitCode",
      "VisitIn",
      "visits",
      "backupVisits",
      "disableI",
      "cancelRoute",
      "User",
      "Username",
      "Password",
      "Token",
      "Modules",
      "ClientId",
      "ClientIdGlobal",
      "DeleteStorage",
    ];
    const preservedValues = {};

    protectedKeys.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        preservedValues[key] = value;
      }
    });

    if (deleteStorage === null || deleteStorage === undefined) {
      await window.localStorage.clear();
      Object.entries(preservedValues).forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });
      await localStorage.setItem("DeleteStorage", JSON.stringify(1));
    }
    var user = localStorage.getItem("Username");
    var passwordField = localStorage.getItem("Password");
    let parsedUser = "";
    let parsedPasswordField = "";
    try {
      parsedUser = user ? JSON.parse(user) : "";
    } catch (e) {
      parsedUser = "";
    }
    try {
      parsedPasswordField = passwordField ? JSON.parse(passwordField) : "";
    } catch (e) {
      parsedPasswordField = "";
    }
    this.setState({
      username: parsedUser || "",
      checkUser: parsedUser || "",
      checkPassword: parsedPasswordField || "",
    });
    if (user === null || passwordField === null) {
      this.setState({ checkPassword: "", checkUser: "", username: "" });
      localStorage.setItem("Username", JSON.stringify(""));
      localStorage.setItem("Password", JSON.stringify(""));
    }
  }

  getTotalStorage = async () => {
    const storageEstimate = await navigator.storage.estimate();
    var usage = 0;
    var quota = 0;
    var remaining = 0;
    await navigator.storage.estimate().then((estimate) => {
      usage = estimate.usage / (1024 * 1024);
      quota = estimate.quota / (1024 * 1024);
      remaining = (estimate.quota - estimate.usage) / (1024 * 1024);
    });
    alert(
      "Total Storage: " +
        quota.toFixed(2) +
        " MB" +
        "\n\r Used Storage: " +
        usage.toFixed(2) +
        " MB" +
        "\n\r Remaining Storage: " +
        remaining.toFixed(2) +
        " MB"
    );
  };

  componentWillUnmount() {
    if (this.unblock) {
      this.unblock();
    }
  }

  encrypt(clearString) {
    var EncryptedString = "";
    var baseIncrement = 128;
    var index = 1;
    while (index <= clearString.length) {
      var ascii =
        clearString[index - 1].charCodeAt(0) + baseIncrement + index - 1;
      var encryptedCharacter = String.fromCharCode(ascii);
      EncryptedString = EncryptedString.concat(encryptedCharacter);
      index++;
    }
    this.setState({ encryptedPassword: EncryptedString });
    return this.state.encryptedPassword;
  }

  FirstAuthentication = async () => {
    const readURL =
      constantURL +
      "LoginController/checkLogin/" +
      this.state.username +
      "/" +
      this.state.password;
    if (navigator.onLine) {
      setTimeout(
        await _get(readURL).then(async (data) => {
          if (data !== undefined) {
            if (data.login === true) {
              await this.setState({
                authenticate: true,
                key: data.login,
                token: data.token,
                modules: data.moduleIds,
                clientId: data.clientId,
                passwordField: data.password,
                username: data.username,
              });
              localStorage.setItem(
                "Modules",
                JSON.stringify(this.state.modules)
              );
              localStorage.setItem(
                "ClientIdGlobal",
                JSON.stringify(this.state.clientId)
              );
              this.state.modules.map(async (item) => {
                if (item === 1) {
                  this.setState({ isMedRep: true });
                  localStorage.setItem("CompleteURI", JSON.stringify(""));
                } else if (item === 2) {
                  this.setState({ isASAP: true });
                  localStorage.setItem(
                    "CompleteURI",
                    JSON.stringify(data.backend + "/ASAPController/")
                  );
                } else if (item === 4 || item === 5) {
                  this.setState({ isWMS: true });
                  localStorage.setItem(
                    "CompleteURI",
                    JSON.stringify(data.backend + "/WMSController/")
                  );
                }
              });
            } else {

              alert(data.Message)
              // const db = ASAPDB;
              // const url =
              //   constantURL +
              //   "Odoo/ASAPController/Authentication?token=" +
              //   this.state.token +
              //   "&user=" +
              //   this.state.username +
              //   "&username=" +
              //   this.state.username +
              //   "&password=" +
              //   this.state.passwordField +
              //   "&db=" +
              //   db;
              // await _post(url).then((response) => {
              //   return response.json().then(async (data) => {
              //     if (data.result === undefined) {
              //       this.setState({ login: false });
              //       alert("Wrong username or password");
              //     } else {
              //       const createUser =
              //         constantURL +
              //         "LoginController/AddUser/" +
              //         4 +
              //         "/" +
              //         this.state.username +
              //         "/" +
              //         this.state.password +
              //         "/REP/" +
              //         this.state.username;
              //       await _post(createUser).then((response) => {
              //         return response.json().then(async (data) => {
              //           this.setState({ newUserId: data });
              //           const createUserModule =
              //             constantURL +
              //             "LoginController/AddUserModule/" +
              //             this.state.newUserId +
              //             "/" +
              //             2 +
              //             "/" +
              //             3;
              //           await _post(createUserModule);
              //           await this.FirstAuthentication();
              //         });
              //       });
              //     }
              //   });
              // });
            }
          }
          this.setState({ login: false });
        }),
        30000
      );
    } else {
      this.setState({ login: false });
      alert("Please connect to the internet");
    }
  };

  login = async () => {
    this.unblock();
    this.setState({ login: true });
    if (this.state.checkUser === "" && this.state.checkPassword === "") {
      await this.FirstAuthentication().then(async () => {
        if (this.state.authenticate && this.state.isMedRep) {
          const keys = [
            "UnsyncedVisits",
            "PlannedVisits",
            "Modules",
            "CheckedDoctorsIndex",
            "HCPDailySched",
            "CheckedDoctors",
            "HCPs",
            "PricelistPrices",
            "Weekly",
            "RouteDate2",
            "UnsyncedVisitsProducts",
            "Pricelist",
            "Items",
            "SelectedClient",
            "Taxes",
            "SelectedRep",
            "Daily",
            "ProductItems",
            "Clients",
            "Catalogs",
            "UserDetail",
            "UnsyncedPlannedVisits",
            "ProductsList",
            "Limits",
            "isSupervisor",
            "Orders",
            "ClientId",
            "Products",
            "CatalogId",
            "UnsyncedVisitsCount",
            "ExpectedTime",
            "UUID",
            "User",
            "Username",
            "RouteDate",
            "Request",
            "Token",
            "Password",
            "UnsyncedVisitsRequests",
            "SpecialRequest",
            "Reps",
            "UnsyncedVisitsCount2",
            "UnsyncedVisits2",
            "UnsyncedVisitsProducts2",
            "UnsyncedVisitsMark2",
            "UnsyncedVisitsBrands2",
            "UnsyncedVisitsRequests",
            "UUID2",
            "CoachDay",
            "Request",
            "UnsyncedVisitsCount",
            "UnsyncedVisits",
            "UnsyncedVisitsMark",
            "UnsyncedVisitsBrands",
            "UnsyncedActivitiesCount",
            "UnsyncedActivities",
            "UUIDAct",
            "UnsyncedActivitiesAssets",
            "UnsyncedActivitiesLogistics",
            "ActivityLogistics",
            "UnsyncedActivities2",
            "UnsyncedActivitiesCount2",
            "UUIDAct2",
            "UnsyncedActivitiesAssets2",
            "UnsyncedActivitiesLogistics2",
            "UnsyncedPlannedVisitsCount",
            "UnsyncedPlannedVisits",
          ];
          const values = [
            "[]",
            "{}",
            "[]",
            "[]",
            '""',
            "[]",
            "[]",
            "[]",
            "false",
            '""',
            "[]",
            "[]",
            "[]",
            "0",
            "[]",
            '""',
            "false",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "0",
            "[]",
            "0",
            "0",
            "[]",
            "[]",
            '""',
            '""',
            '""',
            '""',
            '""',
            '""',
            "[]",
            "[]",
            "[]",
            "0",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "false",
            '""',
            "0",
            "[]",
            "[]",
            "[]",
            "0",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "0",
            "[]",
            "[]",
            "[]",
            "0",
            "[]",
          ];

          keys.map((value, index) => {
            localStorage.setItem(value, values[index]);
          });

          const readURL =
            constantURL +
            "LoginController/checkLogin/" +
            this.state.username +
            "/" +
            this.state.password;
          await _get(readURL).then((data) => {
            if (data !== undefined) {
              this.setState({
                key: data.login,
                token: data.token,
                modules: data.moduleIds,
                passwordField: data.password,
                username: data.username,
              });
              if( data.login !== true){
                this.setState({error : data.Message})
              }
            } else {
              this.setState({ login: false });
            }
          });
          localStorage.setItem("Modules", JSON.stringify(this.state.modules));
          localStorage.setItem("Username", JSON.stringify(this.state.username));
          localStorage.setItem(
            "Password",
            JSON.stringify(this.state.passwordField)
          );
          localStorage.setItem("Token", JSON.stringify(this.state.token));
          Cookies.set('Token', JSON.stringify(this.state.token), { expires: 30 });

          await Authenticate();

          const readURLOdoo = constantURI() + "odooController/MedRepRead";
          const RepsBody = {
            jsonrpc: "2.0",
            params: {
              method: "search_read",
              model: "res.users",
              args: [],
              kwargs: {
                fields: ["name", "supervisor"],
                domain: [["login", "=", this.state.username]],
              },
            },
            token: this.state.token,
          };
          await _postBody(readURLOdoo, RepsBody).then((response) => {
            return response.json().then(async (data) => {
              if (data && data.result && data.result.length > 0) {
                await this.setState({
                  user: data.result[0].name,
                  isSupervisor: data.result[0].supervisor,
                });
                await localStorage.setItem(
                  "User",
                  JSON.stringify(this.state.user)
                );
                await localStorage.setItem(
                  "isSupervisor",
                  JSON.stringify(this.state.isSupervisor)
                );
              }
            });
          });

          if (this.state.key === true) {
            //var notificationURL = constantURL + "loginController/sendNotification"
            //await fetch(notificationURL, {
            //    method: 'POST'
            //}).then(async () => {

            //})
            this.props.history.push(getLoginLandingRoute());
          } else {
            this.setState({ login: false });
            alert("Please enter a valid username and password");
          }
        }
        if (this.state.authenticate && this.state.isASAP) {
          const keys = [
            "DailyData",
            "DailySummaryReport",
            "UnsyncedTransactions",
            "UnsyncedTransactionsCount",
            "UnsyncedClientsCount",
            "UnsyncedClients",
            "UnsyncedPunchCount",
            "UnsyncedPunchDay",
            "UnsyncedVisitCount",
            "UnsyncedVisitDay",
            "Modules",
            "PricelistPrices",
            "Pricelist",
            "Items",
            "SelectedClient",
            "Taxes",
            "ProductItems",
            "Clients",
            "Catalogs",
            "ProductsList",
            "Orders",
            "ClientId",
            "Products",
            "CatalogId",
            "UUID",
            "Username",
            "Token",
            "Password",
            "User",
            "CurrentTab",
            "LocalDailyVisits",
          ];
          const values = [
            "[]",
            '[{"ordered":0, "visited":0, "collection":0, "OOR":0}]',
            "[]",
            "[]",
            "0",
            "[]",
            "0",
            "[]",
            "0",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "0",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "[]",
            "0",
            "[]",
            "0",
            "[]",
            '""',
            '""',
            '""',
            "[]",
            "[]",
            "[]",
          ];

          keys.map((value, index) => {
            localStorage.setItem(value, values[index]);
          });

          const readURL =
            constantURL +
            "LoginController/checkLogin/" +
            this.state.username +
            "/" +
            this.state.password;
          await _get(readURL).then((data) => {
            if (data !== undefined) {
              this.setState({
                key: data.login,
                token: data.token,
                modules: data.moduleIds,
                passwordField: data.password,
                username: data.username,
              });
              if( data.login !== true){
                this.setState({error : data.Message})
              }
            } else {
              this.setState({ login: false });
            }
          });
          localStorage.setItem("Modules", JSON.stringify(this.state.modules));
          if (this.state.key === true) {
            var notificationURL =
              constantURL + "loginController/sendNotification";
            await fetch(notificationURL, {
              method: "POST",
            }).then(async () => {
              localStorage.setItem(
                "Username",
                JSON.stringify(this.state.username)
              );
              localStorage.setItem(
                "Password",
                JSON.stringify(this.state.passwordField)
              );
              localStorage.setItem("Token", JSON.stringify(this.state.token));
              Cookies.set('Token', JSON.stringify(this.state.token), { expires: 30 });
            });
            this.props.history.push(getLoginLandingRoute());
          } else {
            this.setState({ login: false });
            alert("Please enter a valid username and password");
          }
        }
        if (this.state.authenticate && this.state.isWMS) {
          const readURL =
            constantURL +
            "LoginController/checkLogin/" +
            this.state.username +
            "/" +
            this.state.password;
          await _get(readURL).then((data) => {
            if (data !== undefined) {
              this.setState({
                key: data.login,
                token: data.token,
                modules: data.moduleIds,
                passwordField: data.password,
                username: data.username,
              });
              if( data.login !== true){
                this.setState({error : data.Message})
              }
            } else {
              this.setState({ login: false,  });
              
            }
          });
          localStorage.setItem("Modules", JSON.stringify(this.state.modules));
          if (this.state.key === true) {
            if (!this.state.alertUndefined) {
              localStorage.setItem(
                "Username",
                JSON.stringify(this.state.username)
              );
              localStorage.setItem(
                "Password",
                JSON.stringify(this.state.passwordField)
              );
              localStorage.setItem("Token", JSON.stringify(this.state.token));
              Cookies.set('Token', JSON.stringify(this.state.token), { expires: 30 });
              this.props.history.push(getLoginLandingRoute());
            }
          } else {
            this.setState({ login: false });
            alert(this.state.error);
          }
        }
      });
    } else {
      const readURL =
        constantURL +
        "LoginController/checkLogin/" +
        this.state.username +
        "/" +
        this.state.password;
      const cachedToken = JSON.parse(localStorage.getItem("Token"));
      const cachedModules = JSON.parse(localStorage.getItem("Modules"));
      let data;
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);
        const response = await fetch(readURL, {
          method: "GET",
          signal: controller.signal,
        });
        clearTimeout(timeoutId);
        data = await response.json();
      } catch (e) {
        data = undefined;
      }
      if (data && data.login === true && data.token) {
        this.setState({ token: data.token });
        localStorage.setItem("Offline", JSON.stringify(false));
        localStorage.setItem("Token", JSON.stringify(data.token));
        Cookies.set('Token', JSON.stringify(this.state.token), { expires: 30 });
        this.props.history.push(getLoginLandingRoute());
      } else if (
        cachedToken &&
        cachedToken !== "" &&
        cachedModules &&
        cachedModules.length > 0
      ) {
        localStorage.setItem("Offline", JSON.stringify(true));
        cachedModules.map((item) => {
          if (item === 1) this.setState({ isMedRep: true });
          if (item === 2) this.setState({ isASAP: true });
          if (item === 4 || item === 5) this.setState({ isWMS: true });
        });
        this.setState({ authenticate: true, login: false });
        this.props.history.push(getLoginLandingRoute());
      } else {
        this.setState({ login: false });
        alert("Please connect to the internet to login.");
      }
    }
  };

  changeUser = async () => {
    const { changePwdInput, username } = this.state;
    
    // Validate password input
    if (!changePwdInput || changePwdInput.trim() === "") {
      alert("Please enter your password to switch users");
      return;
    }
    
    try {
        // Compare input password with server password
        if (changePwdInput === "ABM0SASO") {
          // Password matches - proceed with user switch
          await window.localStorage.clear();
          await clear();
          await window.location.reload();
          this.closeAlertChange();
        } else {
          alert("Incorrect password. Please try again.");
          this.setState({ changePwdInput: "" });
        }      
    } catch (error) {
      console.error("Error verifying password:", error);
      alert("An error occurred while verifying your password.");
    }
  };

  closeAlertChange = () => {
    this.setState({ showAlertChange: false });
  };

  showAlertChange = () => {
    this.setState({ showAlertChange: true });
  };

  filterLocalStorage = async (searchTerm) => {
    var result = false;
    if (this.state.isASAP) {
      const keys = Object.keys(localStorage);
      const filteredKeys = keys.filter((key) => key.includes(searchTerm));
      await filteredKeys.map((item) => {
        const itemToPush = JSON.parse(localStorage.getItem(item));
        if (itemToPush !== 0) {
          if (itemToPush.length !== 0) {
            result = true;
          }
        }
      });
    } else if (this.state.isWMS) {
      const holdWMS = JSON.parse(localStorage.getItem("HoldWMS"));
      const holdOMS = JSON.parse(localStorage.getItem("HoldOMS"));

      if (
        (holdWMS !== null && holdWMS.length !== 0) ||
        (holdOMS !== null && holdOMS.length !== 0)
      ) {
        result = true;
      }
    }
    return result;
  };

  onClickSwitchUser = async () => {
    if (await this.filterLocalStorage("sync")) {
      alert(
        "You can not switch users because you have data that are not synced yet. Please connect to the internet, sync the data, then switch users."
      );
    } else {
      this.showAlertChange();
    }
  };

  render() {
    return (
      <div>
        {!this.state.alertUndefined ? null : (
          <div className="col alert alert-danger">
            <div className="row">
              <h6 className="col-sm-8">There seems to be a problem.</h6>
              <div className="col d-flex flex-row-reverse">
                <div
                  className="btn"
                  style={stylesMed.wideButton}
                  onClick={() => window.location.reload()}
                >
                  Reload
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="col m-3">
          <DiscOutline
            className="btn"
            onClick={() => this.getTotalStorage()}
            color={"#00bfff"}
            height="50px"
            width="50px"
          />
        </div>
        <div
          className="btn mt-3 Login-switchuser"
          onClick={() => this.onClickSwitchUser()}
        >
          <AiOutlineUserSwitch className="Login-icon" />
        </div>

        <div className="wrapper fadeInDown">
          <div id="formContent">
            <div className="fadeIn first mt-5 m-5 mb-5">
              {/* <FaUserAlt className="Login-icon-user" /> */}
              <img src={ASAP} className="asaplogo" alt="EDM Logo" />
              <h4 className="mt-3">SIGN IN</h4>
            </div>

            <form>
              <input
                type="text"
                id="login"
                className="fadeIn second inputLogin"
                name="login"
                placeholder="USERNAME"
                autoFocus
                onChange={(e) => this.Username(e.target.value)}
                value={this.state.username}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) this.login();
                }}
              />
              <input
                type="password"
                id="password"
                className="fadeIn third inputLogin"
                name="login"
                placeholder="PASSSWORD"
                onChange={(e) => this.Password(e.target.value)}
                value={this.state.password}
                onKeyDown={(e) => {
                  if (e.keyCode === 13) this.login();
                }}
              />
              {/* <input type="submit" className="fadeIn fourth" value="Log In" onClick={() => this.login()}/> */}
              {!this.state.login ? (
                <div
                  className="btn Login-btn fadeIn fourth"
                  onClick={() => this.login()}
                >
                  Login
                </div>
              ) : (
                <div
                  className="btn Login-btn disabled"
                  onClick={() => this.login()}
                >
                  Login
                </div>
              )}
            </form>

            <div id="formFooter">
              <h6 className="text-center">Powered by</h6>
              <img src={EDMLogo} className="edmlogo" alt="EDM Logo" />
            </div>
          </div>
        </div>

        {/* <div className="Login-center">
          <div className="Login-form-container mt-3">
            <div className="Login-form">
              <div className="Login-form-content">
                <FaUserAlt className="Login-icon-user col" />
                <h3 className="Login-form-title mt-2">SIGN IN</h3>
                <div className="Login-form-group">
                  <div className="Login-names row">
                    <label className="Login-user col-1">Username</label>
                  </div>
                  <input
                    className="form-control mt-1"
                    autoFocus
                    placeholder="Enter username"
                    onChange={(e) => this.Username(e.target.value)}
                    value={this.state.username}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) this.login();
                    }}
                  />
                </div>
                <div className="Login-form-group mt-3">
                  <div className="Login-names row">
                    <label className="Login-user col-1">Password</label>
                  </div>
                  <input
                    type="password"
                    className="form-control mt-1"
                    placeholder="Please Enter A Password"
                    onChange={(e) => this.Password(e.target.value)}
                    value={this.state.password}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) this.login();
                    }}
                  />
                </div>
                <div className="d-grid gap-2 mt-5">
                  {!this.state.login ? (
                    <div className="btn Login-btn" onClick={() => this.login()}>
                      Login
                    </div>
                  ) : (
                    <div
                      className="btn Login-btn disabled"
                      onClick={() => this.login()}
                    >
                      Login
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div>
          <div className="Login-EDMlogo col text-center mt-5">
            <h6 className="text-center mt-5">Powered by</h6>
            <img src={EDMLogo} className="edmlogo" alt="EDM Logo" />
          </div>
        </div> */}

        <Modal
          show={this.state.showAlertChange}
          onHide={this.closeAlertChange}
          animation={false}
        >
          <Modal.Header>
            <h5>Switch User</h5>
          </Modal.Header>
          <Modal.Body style={stylesCommon.changeUser}>
            Switching users will <b>DELETE ALL DATA FROM THIS DEVICE</b>. Are
            you sure you want to switch users?
          </Modal.Body>
          <Modal.Body>
            <div style={{ marginBottom: "15px" }}>
              <label htmlFor="changePwd" style={{ marginBottom: "5px", display: "block" }}>
                Enter your password to confirm:
              </label>
              <input
                id="changePwd"
                type="password"
                className="form-control"
                value={this.state.changePwdInput}
                onChange={(e) => this.ChangePwdInput(e.target.value)}
                placeholder="Password"
              />
            </div>
            <div>
              <div
                className="btn btn-primary"
                style={stylesCommon.deleteButtonAlert}
                onClick={this.changeUser}
              >
                Switch
              </div>
              <div
                className="btn btn-danger"
                style={stylesCommon.cancelButtonAlert}
                onClick={() => this.closeAlertChange()}
              >
                Cancel
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
